import React from 'react';

// Types
import { ButtonProps } from './types';

// Components Styled
import { Container, Text } from './styles';

/**
 * Primary UI component for user interaction
 */
export const MainButton = ({
  variant = 'primary',
  text,
  disabled,
  ...props
}: ButtonProps): JSX.Element => {
  const getTextColor = () => {
    if (disabled) {
      return variant === 'primary' ? 'white' : 'backgroundLila';
    }

    switch (variant) {
      case 'primary':
        return 'white';
      case 'secondary':
        return 'garnet';
      case 'tertiary':
        return 'blueActuation';
      default:
        return 'garnet';
    }
  };

  return (
    <Container variant={variant} disabled={disabled} {...props}>
      <Text colorText={getTextColor()} size="S">
        {text}
      </Text>
    </Container>
  );
};
